import { FC, useEffect, useRef, useState } from 'react';
import { getUpdatedMiniAppLink } from '../../internetBar.helper';
import { useSession } from '@marriott/mi-headless-utils';
import isEmpty from 'lodash/isEmpty';

export const InternetBarWeChatPseudoLink: FC<{ weChatEnrollmentSourceCode: string }> = ({
  weChatEnrollmentSourceCode,
}) => {
  const { datalayer } = useSession();

  const linkRef = useRef<HTMLAnchorElement | null>(null);
  const [triggered, setTriggered] = useState<boolean>(false);
  const [urlScheme, setUrlScheme] = useState<string>('');

  // pseudo "ios_wechat" — ensure we only auto-fire once
  const autoOpen = () => {
    if (triggered) return;
    linkRef.current?.click();
    setTriggered(true);
  };

  useEffect(() => {
    if (!isEmpty(datalayer)) {
      setUrlScheme(getUpdatedMiniAppLink(weChatEnrollmentSourceCode, datalayer));
    }
  }, [datalayer]);

  // Start a timer to fire the pseudo link; cancel if user clicks manually
  useEffect(() => {
    if (!urlScheme) return;
    const timer = window.setTimeout(autoOpen, 2000);

    const onClick = () => window.clearTimeout(timer);
    const el = linkRef.current;
    el?.addEventListener('click', onClick);

    return () => {
      window.clearTimeout(timer);
      el?.removeEventListener('click', onClick);
    };
  }, [urlScheme, triggered]);

  return (
    <a
      ref={linkRef}
      href={urlScheme}
      style={{ position: 'absolute', width: 0, height: 0, overflow: 'hidden' }}
      aria-hidden="true"
    >
      Open WeChat Link
    </a>
  );
};
